/* Seção 05: mesma mecânica compartilhada da Seção 04 */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-rooms]').forEach(function (section) {
      if (section._efRoomsBound || !window.EFAccordion) return;
      section._efRoomsBound = true;
      window.EFAccordion.attach(section, {
        item: '[data-item]',
        head: '.ef-rooms__row',
        body: '.ef-rooms__body',
        openClass: 'is-open'
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
